module.exports = __webpack_public_path__ + "static/media/embroidery-polo-shirts-with-logo.36f00d53.png";